<!-- LAYOUT: default.vue -->

<script setup lang="ts">
//
// ============================================================================
// COMPOSABLES
// ============================================================================
//

const config = useRuntimeConfig();

//
// ============================================================================
// HEAD CONFIGURATION
// ============================================================================
//

// Configure favicon for reverse proxy deployment
useHead({
  link: [
    {
      rel: "icon",
      type: "image/x-icon",
      href: pathCombine(config.public.APP_BASE_URL, "/favicon.ico"),
    },
  ],
});
</script>

<template>
  <v-app>
    <slot />
  </v-app>
</template>
